/**
 * 解析登录框输入：中国大陆手机号或邮箱。
 * @returns {{ ok: true, account: string } | { ok: false, error: string }}
 */
export function parseLoginAccountInput(raw) {
  const s = String(raw || '').trim();
  if (!s) {
    return { ok: false, error: '请输入手机号或邮箱' };
  }

  const digits = s.replace(/\D/g, '');
  if (/^1[3-9]\d{9}$/.test(digits)) {
    return { ok: true, account: digits };
  }
  if (digits.length === 13 && digits.startsWith('86')) {
    const m = digits.slice(2);
    if (/^1[3-9]\d{9}$/.test(m)) {
      return { ok: true, account: m };
    }
  }

  if (s.includes('@')) {
    const em = s.toLowerCase().trim();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
      return { ok: true, account: em };
    }
    return { ok: false, error: '邮箱格式不正确' };
  }

  return { ok: false, error: '请输入有效的手机号或邮箱' };
}
